import { Observer } from 'mobx-react-lite';
import React from 'react';
function BaseCalendarEventDefaultTitleRenderer(props) {
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null, props.calendarEvent.name)); } });
}
export default BaseCalendarEventDefaultTitleRenderer;
